import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { DirFilterBarService } from "./dir-filter-bar.service";
import { CommonService } from "../services/common-service";
import { ROLE_CONSTANTS, ROLE_GROUP_CONSTANTS } from "../../../shared/constants/role.constants";
import { RoleService } from "../../../shared/constants/role.service";
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: "app-dir-filter-bar",
  standalone: true,
  imports: [CommonModule, FormsModule, NgMultiSelectDropDownModule],
  templateUrl: "./dir-filter-bar.component.html",
  styleUrls: ["./dir-filter-bar.component.scss"],
})
export class DirFilterBarComponent implements OnInit {
  isOutletSelect:boolean = false
  ROLE_CONSTANTS = ROLE_CONSTANTS;
  ROLE_GROUP_CONSTANTS = ROLE_GROUP_CONSTANTS;
  hasAppliedFilter: boolean = false;
  users: any[] = [];
  filters: any;
  zone_id: any;
  role_id: any;
  user_id: any;
  ZoneManagerList: any[] = [];
  RegionManagerList: any[] = [];
  AllRegionManagerList: any[] = [];
  AreaManagerList: any[] = [];
  AllAreaManagerList: any[] = [];
  zoneSet = new Set<number>();
  regionSet = new Set<number>();
  areaSet = new Set<number>();

  @Input() showOutlets: boolean = false;
  OutletList: any[] = [];
  selectedOutlets: any[] = [];
  outletSet = new Set<number>();

  outletSettings = {
    singleSelection: true,
    enableCheckAll: false,
    idField: "id",
    textField: "outlet_name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableFullObject: true,
  };

  constructor(
    public toaster: ToastrService,
    public roleService: RoleService,
    private filterService: DirFilterBarService,
    private service: CommonService
  ) { }

  zoneSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: "zone_id",
    textField: "username",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableFullObject: true
  };
  regionSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: "user_id",
    textField: "username",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableFullObject: true,
  };
  areaSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: "user_id",
    textField: "username",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableFullObject: true,
  };

  ngOnInit() {
    console.log('dir filter-bar');
    this.loadoutlets();
    this.updateFilterData();
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.role_id = loginResponse.data?.user?.role_id;
        this.zone_id = loginResponse.data?.user?.zone_id;
        this.user_id = loginResponse.data?.user?.id;
      }
    }
    this.loadFilters(); // true or false dynamically
    // if (this.showOutlets && (this.role_id === 10 || this.role_id === 8)) {
    //   this.loadoutlets();
    // }
    // this.apply();
  }
  updateFilterData() {
    const storedData = sessionStorage.getItem("dirfilterObj");

    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        console.log('on update filterData', parsed)
        // Add existing values to sets
        if (parsed.zone_id && Array.isArray(parsed.zone_id)) {
          parsed.zone_id.forEach((id: number) => this.zoneSet.add(id));
        }
        if (parsed.region_user_id && Array.isArray(parsed.region_user_id)) {
          parsed.region_user_id.forEach((id: number) => this.regionSet.add(id));
        }
        if (parsed.area_user_id && Array.isArray(parsed.area_user_id)) {
          parsed.area_user_id.forEach((id: number) => this.areaSet.add(id));
        }
        if (parsed.outlet_id && Array.isArray(parsed.outlet_id)) {
          console.log('on update filterData', parsed.outlet_id)
          parsed.outlet_id.forEach((id: number) => this.outletSet.add(id));
        }
        if (this.zoneSet.size > 0 || this.regionSet.size > 0 || this.outletSet.size > 0) {
          this.hasAppliedFilter = true;
        }
      } catch (err) {
        console.error("Invalid session data:", err);
      }
    }
  }
  loadFilters() {
    this.filterService.getZRAFilterData().subscribe((data) => {
      this.ZoneManagerList = this.role_id == ROLE_CONSTANTS.HO ? data?.ZoneManager : [];

      // 🟢 Restore selected zones based on Set
      this.selectedZonalMgrs = (this.ZoneManagerList || []).filter((zone: any) =>
        this.zoneSet.has(zone.zone_id)
      );

      this.RegionManagerList = this.role_id === ROLE_CONSTANTS.HO
        ? data?.RegionManager || []
        : this.role_id === ROLE_CONSTANTS.ZM
          ? (data?.RegionManager || []).filter(
            (rm: any) => rm.zone_id === this.zone_id
          )
          : [];

      // 🟢 Restore selected regions based on Set
      this.selectedRegionalMgrs = this.RegionManagerList.filter((region: any) =>
        this.regionSet.has(region.user_id)
      );
      this.selectedRegionalMgrsFull = [...this.selectedRegionalMgrs];

      this.AllRegionManagerList = this.role_id === ROLE_CONSTANTS.HO
        ? data?.RegionManager || []
        : this.role_id === ROLE_CONSTANTS.ZM
          ? (data?.RegionManager || []).filter(
            (rm: any) => rm.zone_id === this.zone_id
          )
          : [];
      this.AreaManagerList = this.role_id === ROLE_CONSTANTS.HO
        ? data?.AreaManager || []
        : this.role_id === ROLE_CONSTANTS.ZM
          ? (data?.AreaManager || []).filter(
            (am: any) => am.zone_id === this.zone_id
          ) :
          this.role_id === ROLE_CONSTANTS.RM
            ?
            (() => {
              // 🧩 find RM's outlets from RegionManagerList
              const outlets =
                data?.RegionManager.find(
                  (rg: any) => rg.user_id === this.user_id
                )?.outlet_id || [];
              // 🧩 filter AreaManagers whose outlet arrays overlap with RM's outlets
              return (data?.AreaManager || []).filter((am: any) =>
                am.outlet_id?.some((outletId: any) => outlets.includes(outletId))
              );
            })()
            : [];
      this.AllAreaManagerList = this.role_id === ROLE_CONSTANTS.HO
        ? data?.AreaManager || []
        : this.role_id === ROLE_CONSTANTS.ZM
          ? (data?.AreaManager || []).filter(
            (am: any) => am.zone_id === this.zone_id
          ) :
          this.role_id === ROLE_CONSTANTS.RM
            ?
            (() => {
              // 🧩 find RM's outlets from RegionManagerList
              const outlets =
                data?.RegionManager.find(
                  (rg: any) => rg.user_id === this.user_id
                )?.outlet_id || [];
              // 🧩 filter AreaManagers whose outlet arrays overlap with RM's outlets
              return (data?.AreaManager || []).filter((am: any) =>
                am.outlet_id?.some((outletId: any) => outlets.includes(outletId))
              );
            })()
            : [];

      // 🟢 Restore selected areas based on Set
      this.selectedAreaMgrs = this.AreaManagerList.filter((area: any) =>
        this.areaSet.has(area.user_id)
      );
      this.selectedAreaMgrsFull = [...this.selectedAreaMgrs];

      // if (this.showOutlets) {
      //   if (this.role_id === 10 || this.role_id === 8) {
      //     this.loadoutlets();
      //   } else if (this.selectedAreaMgrsFull && this.selectedAreaMgrsFull.length > 0) {
      //     const request = this.selectedAreaMgrsFull.flatMap((a: any) => a.outlet_id || []);
      //     this.filterService.getOutletsDatabyOutletIDdropdown(request).subscribe((data) => {
      //       this.OutletList = data || [];
      //       this.selectedOutlets = this.OutletList.filter((item: any) => this.outletSet.has(item.id));
      //     });
      //   }
      // }
    });
  }

  // @Input() roleId!: number; 

  // Zone
  @Input() zonalList: any[] = [];
  selectedZonalMgrs: any[] = [];
  @Output() selectedZonalMgrsChange = new EventEmitter<any[]>();
  @Output() zoneSelect = new EventEmitter<any>();
  @Output() zoneDeSelect = new EventEmitter<any>();

  // Region
  @Input() regionalList: any[] = [];
  selectedRegionalMgrs: any[] = [];
  selectedRegionalMgrsFull: any = [];
  @Output() selectedRegionalMgrsChange = new EventEmitter<any[]>();
  @Output() regionSelect = new EventEmitter<any>();
  @Output() regionDeSelect = new EventEmitter<any>();

  // Area
  @Input() areaList: any[] = [];
  @Input() selectedAreaMgrs: any[] = [];
  selectedAreaMgrsFull: any = [];
  @Output() selectedAreaMgrsChange = new EventEmitter<any[]>();
  @Output() areaSelect = new EventEmitter<any>();
  @Output() areaDeSelect = new EventEmitter<any>();

  // Actions
  // @Output() showErrorForRegion = new EventEmitter<void>();
  // @Output() showErrorForArea = new EventEmitter<void>();
  @Output() applyManagers = new EventEmitter<any>();
  @Output() clearFilter = new EventEmitter<boolean>();

  onZoneSelect(selectedItem: any): void {
    if (!this.selectedZonalMgrs) {
      this.selectedZonalMgrs = [];
    }
    this.zoneSet.add(selectedItem.zone_id);
    const zoneIds = Array.from(this.zoneSet);

    // let zoneId: any = this.selectedZonalMgrs
    //   .filter((item: any) => item && item.zone_id !== undefined)
    //   .map((item: any) => item.zone_id);
    this.RegionManagerList = [
      ...this.AllRegionManagerList.filter((rm: any) =>
        zoneIds.includes(rm.zone_id)
      ),
    ];
    // this.zoneSelect.emit(this.selectedZonalMgrs);
    // this.selectedZonalMgrsChange.emit(this.selectedZonalMgrs);
    // let zoneArr = [...this.selectedZonalMgrs];
    // emit to service
    this.service.updateSelectedZones({ type: 'select', zoneId: selectedItem.zone_id });
  }

  onZoneDeSelect(deSelectedItem: any): void {
    // Remove from local ID list
    this.selectedZonalMgrs = this.selectedZonalMgrs.filter(
      (zone_id) => zone_id !== deSelectedItem.zone_id
    );
    // 🔹 2. Update Set
    this.zoneSet.delete(deSelectedItem.zone_id);
    // 🔹 3. Build updated zoneId array
    const zoneIds = Array.from(this.zoneSet);

    // 🔹 4. Remove regions belonging to deselected zone from regionSet
    const removedRegionIds = this.AllRegionManagerList
      .filter((region: any) => region.zone_id === deSelectedItem.zone_id)
      .map((region: any) => region.user_id);
    removedRegionIds.forEach((id: number) => this.regionSet.delete(id));

    // 🔥 5️⃣ NEW — Remove areas belonging to deselected zone from areaSet
    const removedAreaIds = this.AllAreaManagerList
      .filter((area: any) => area.zone_id === deSelectedItem.zone_id)
      .map((area: any) => area.user_id);

    removedAreaIds.forEach((id: number) => this.areaSet.delete(id));

    // Update RegionManagerList
    if (zoneIds.length > 0) {
      this.RegionManagerList = [
        ...this.AllRegionManagerList.filter((zone: any) =>
          zoneIds.includes(zone.zone_id)
        ),
      ];
      // 🔹 Update selectedRegionalMgrsFull to only include remaining zones
      if (this.selectedRegionalMgrsFull) {
        this.selectedRegionalMgrsFull = this.selectedRegionalMgrsFull.filter(
          (region: any) => zoneIds.includes(region.zone_id)
        );
      }

      // 🔹 Update selectedRegionalMgrs (for dropdown ngModel)
      this.selectedRegionalMgrs = [...this.selectedRegionalMgrsFull];

      // 🔹 Update AreaManagerList based on remaining selectedRegionalMgrsFull
      this.AreaManagerList = this.AllAreaManagerList.filter((area) =>
        area.outlet_id.some((areaId: number) =>
          this.selectedRegionalMgrsFull.some((selected: any) =>
            selected.outlet_id.includes(areaId)
          )
        )
      );
      // 🔹 Update selectedAreaMgrsFull and selectedAreaMgrs to remove invalid areas
      if (this.selectedAreaMgrsFull) {
        this.selectedAreaMgrsFull = this.selectedAreaMgrsFull.filter((areaMgr: any) =>
          areaMgr.outlet_id.some((areaId: number) =>
            this.selectedRegionalMgrsFull.some((selected: any) =>
              selected.outlet_id.includes(areaId)
            )
          )
        );
      }
      this.selectedAreaMgrs = [...this.selectedAreaMgrsFull];
      if (this.showOutlets) {
        const request = this.selectedAreaMgrsFull.flatMap((a: any) => a.outlet_id || []);
        this.OutletList = [];
        this.filterService.getOutletsDatabyOutletIDdropdown(request).subscribe((data) => {
          this.OutletList = data || [];
          const idsselectedOutlets = new Set(this.selectedOutlets.map((item) => item.id));
          this.selectedOutlets = this.OutletList.filter((item) => idsselectedOutlets.has(item.id));
        });
      }
    } else {
      this.RegionManagerList = this.AllRegionManagerList; // ✅ reset region list if no zone selected
      this.selectedRegionalMgrs = []; // ✅ reset selected regions as well
      this.selectedRegionalMgrsFull = [];
      // Reset AreaManagerList as well
      this.AreaManagerList = this.AllAreaManagerList;
      this.selectedAreaMgrs = [];
      this.selectedAreaMgrsFull = [];
      if (this.showOutlets) {
        this.selectedOutlets = [];
        this.OutletList = [];
      }
    }
    // Emit to parent
    // this.zoneDeSelect.emit(this.selectedZonalMgrs);
    // Optionally: emit updated selectedZonalMgrs for two-way binding
    // this.selectedZonalMgrsChange.emit(this.selectedZonalMgrs);
    // let unselectZoneArr = [deSelectedItem];
    this.service.updateSelectedZones({ type: 'unselect', zoneId: deSelectedItem.zone_id });
  }

  onRegionSelect(selectedItem: any) {
    if (!this.selectedRegionalMgrs) {
      this.selectedRegionalMgrs = [];
    }
    // ✅ Add to Set
    this.regionSet.add(selectedItem.user_id);
    // Find the full object from AllRegionManagerList
    const fullObj = this.AllRegionManagerList.find(
      mgr => mgr.user_id === selectedItem.user_id
    );

    // Add it to selectedRegionalMgrsFull array (full objects)
    if (!this.selectedRegionalMgrsFull) this.selectedRegionalMgrsFull = [];

    if (!this.selectedRegionalMgrsFull.some((x: any) => x.user_id === fullObj.user_id)) {
      this.selectedRegionalMgrsFull.push(fullObj);
    }

    // Filter AreaManagerList based on selectedRegionalMgrs
    if (this.selectedRegionalMgrsFull.length > 0) {
      // Filter AreaManagerList: include only those whose user_id array has any match with selectedRegionalMgrsFull
      this.AreaManagerList = this.AllAreaManagerList.filter((area) =>
        area.outlet_id.some((areaId: number) =>
          this.selectedRegionalMgrsFull.some((selected: any) =>
            selected.outlet_id.includes(areaId)
          )
        )
      );
    } else {
      // Reset AreaManagerList and selectedAreaMgrs if no region selected
      this.AreaManagerList = this.AllAreaManagerList;
      this.selectedAreaMgrs = [];
      // this.selectedAreaMgrsChange.emit(this.selectedAreaMgrs);
    }
    let obj = this.RegionManagerList.find((f: any) => f.user_id == selectedItem.user_id);
    this.service.updateSelectedRegions({ type: 'select', data: obj })
    // this.regionSelect.emit(this.selectedRegionalMgrsFull);
    // this.selectedRegionalMgrsChange.emit(this.selectedRegionalMgrsFull);
  }

  onregionDeSelect(deSelectedItem: any) {
    // Ensure array initialized
    if (!this.selectedRegionalMgrsFull) this.selectedRegionalMgrsFull = [];
    // ✅ Remove from Set
    this.regionSet.delete(deSelectedItem.user_id);

    // 🔹 Remove areas linked to the deselected region
    const removedAreaIds = this.AllAreaManagerList
      .filter((area: any) =>
        deSelectedItem.outlet_id?.some((id: number) =>
          area.outlet_id?.includes(id)
        )
      )
      .map((area: any) => area.user_id);

    removedAreaIds.forEach((id: number) => this.areaSet.delete(id));
    // Remove the deselected item from full objects array
    this.selectedRegionalMgrsFull = this.selectedRegionalMgrsFull.filter(
      (mgr: any) => mgr.user_id !== deSelectedItem.user_id
    );
    if (this.selectedRegionalMgrsFull.length > 0) {
      // Filter AreaManagerList: include only those whose outlet_id array has any match with remaining selectedRegionalMgrs
      this.AreaManagerList = this.AllAreaManagerList.filter((area) =>
        area.outlet_id.some((areaId: number) =>
          this.selectedRegionalMgrsFull.some((selected: any) =>
            selected.outlet_id.includes(areaId)
          )
        )
      );
      // ALSO update selectedAreaMgrs to remove area managers no longer valid
      if (this.selectedAreaMgrsFull) {
        this.selectedAreaMgrsFull = this.selectedAreaMgrsFull.filter((areaMgr: any) =>
          areaMgr.outlet_id.some((areaId: number) =>
            this.selectedRegionalMgrsFull.some((selected: any) =>
              selected.outlet_id.includes(areaId)
            )
          )
        );
      }
      // Update the dropdown model
      this.selectedAreaMgrs = [...this.selectedAreaMgrsFull];
      if (this.showOutlets) {
        const request = this.selectedAreaMgrsFull.flatMap((a: any) => a.outlet_id || []);
        this.OutletList = [];
        this.filterService.getOutletsDatabyOutletIDdropdown(request).subscribe((data) => {
          this.OutletList = data || [];
          const idsselectedOutlets = new Set(this.selectedOutlets.map((item) => item.id));
          this.selectedOutlets = this.OutletList.filter((item) => idsselectedOutlets.has(item.id));
        });
      }
    } else {
      this.AreaManagerList = this.AllAreaManagerList;
      this.selectedAreaMgrs = [];
      this.selectedAreaMgrsFull = [];
      if (this.showOutlets) {
        this.selectedOutlets = [];
        this.OutletList = [];
      }
    }
    let obj = this.RegionManagerList.find((f: any) => f.user_id == deSelectedItem.user_id);
    this.service.updateSelectedRegions({ type: 'unselect', data: obj })
    // this.regionDeSelect.emit(this.selectedRegionalMgrsFull);
    // this.selectedRegionalMgrsChange.emit(this.selectedRegionalMgrsFull);
  }
  onAreaSelect(selectedItem: any) {
    if (!this.selectedAreaMgrs) {
      this.selectedAreaMgrs = [];
    }

    if (!this.selectedAreaMgrsFull) this.selectedAreaMgrsFull = [];

    // ✅ Add to Set
    this.areaSet.add(selectedItem.user_id);

    // Find full object from AllAreaManagerList
    const fullObj = this.AllAreaManagerList.find(
      (mgr: any) => mgr.user_id === selectedItem.user_id
    );
    // Agar already nahi hai to push karo
    if (fullObj && !this.selectedAreaMgrsFull.some((x: any) => x.user_id === fullObj.user_id)) {
      this.selectedAreaMgrsFull.push(fullObj);
    }
    this.service.updateSelectedAreas({ type: 'select', data: fullObj })
    if (this.showOutlets) {
      let request: any = this.selectedAreaMgrsFull.flatMap((a: any) => a.outlet_id || []);
      this.filterService.getOutletsDatabyOutletIDdropdown(request).subscribe((data) => {
        this.OutletList = data || [];
      });
    }
    // this.areaSelect.emit(this.selectedAreaMgrsFull);
    // this.selectedAreaMgrsChange.emit(this.selectedAreaMgrsFull);
  }

  onAreaDeSelect(deSelectedItem: any) {
    // ✅ Remove from Set
    this.areaSet.delete(deSelectedItem.user_id);

    if (this.selectedAreaMgrsFull) {
      this.selectedAreaMgrsFull = this.selectedAreaMgrsFull.filter(
        (mgr: any) => mgr.user_id !== deSelectedItem.user_id
      );
    }
    // Find full object from AllAreaManagerList
    const fullObj = this.AllAreaManagerList.find(
      (mgr: any) => mgr.user_id === deSelectedItem.user_id
    );
    this.service.updateSelectedAreas({ type: 'unselect', data: fullObj })
    if (this.showOutlets) {
      const request = this.selectedAreaMgrsFull.flatMap((a: any) => a.outlet_id || []);
      this.OutletList = [];
      this.filterService.getOutletsDatabyOutletIDdropdown(request).subscribe((data) => {
        this.OutletList = data || [];
        const idsselectedOutlets = new Set(this.selectedOutlets.map((item) => item.id));
        this.selectedOutlets = this.OutletList.filter((item) => idsselectedOutlets.has(item.id));
      });
    }
    // this.areaDeSelect.emit(this.selectedAreaMgrsFull);
    // this.selectedAreaMgrsChange.emit(this.selectedAreaMgrsFull);
  }
  // Helper function to flatten & get unique values
  getUniqueIds(arr: any[], key: string): any[] {
    return Array.from(new Set(
      arr.flatMap(item => item[key] || [])
    ));
  }
  clearFilters(isClear: boolean) {
    let getDateToggleData = this.service.getDateRangeToggleData();
    if (this.selectedZonalMgrs.length > 0
      || this.selectedRegionalMgrs.length > 0
      || this.selectedAreaMgrs.length > 0
      || (this.showOutlets && this.selectedOutlets.length > 0)
    ) {
      isClear = true;
    }
    this.selectedZonalMgrs = [];
    this.selectedRegionalMgrs = [];
    this.selectedAreaMgrs = [];
    this.selectedRegionalMgrsFull = [];
    this.selectedAreaMgrsFull = [];
    if (this.showOutlets) {
      this.selectedOutlets = [];
      this.OutletList = [];
      this.outletSet.clear();
      // if (this.role_id === 10 || this.role_id === 8) {
      // }
      this.loadoutlets();
      this.isOutletSelect = false;
    }

    this.RegionManagerList = [...this.AllRegionManagerList];
    this.AreaManagerList = [...this.AllAreaManagerList];

    // Emit events
    // this.selectedZonalMgrsChange.emit(this.selectedZonalMgrs);
    // this.selectedRegionalMgrsChange.emit(this.selectedRegionalMgrs);
    // this.selectedAreaMgrsChange.emit(this.selectedAreaMgrs);
    // if (!isClear && !this.hasAppliedFilter) {
    //   this.toaster.warning('Already cleared!');
    // }
    if (!this.hasAppliedFilter) {
      // this.toaster.warning('Already cleared!');
      return;
    }
    this.hasAppliedFilter = false;
    this.zoneSet.clear();
    this.regionSet.clear();
    this.areaSet.clear();
    this.outletSet.clear();
    sessionStorage.removeItem("dirfilterObj");
    let obj: any = {};
    if (getDateToggleData && getDateToggleData?.fromDate && getDateToggleData?.toDate) {
      obj['fromDate'] = getDateToggleData?.fromDate;
      obj['toDate'] = getDateToggleData?.toDate;
    }
    if (getDateToggleData && getDateToggleData?.hyperlocal_outlet) {
      obj['hyperlocal_outlet'] = getDateToggleData?.hyperlocal_outlet;
    }
    this.service.clearAllSelections();
    this.clearFilter.emit(obj); // notify parent
  }
  getUniqueIdsFromArray(arr: any[], key: string): any[] {
    return Array.from(new Set(arr.map(item => item[key]).filter(Boolean)));
  }

  /**
   * selectedArr = ids array (like this.selectedRegionalMgrs)
   * fullArr = full object array (like this.selectedRegionalMgrsFull)
   * matchKey = key to match both (like 'user_id')
   * extractKey = key to extract from matched full objects (like 'region_id')
   */
  getUniqueIdsFromLinkedArrays(selectedArr: any[], fullArr: any[], matchKey: string, extractKey: string): any[] {
    const matchedObjects = selectedArr.flatMap(sel =>
      fullArr.filter(full => full[matchKey] === sel[matchKey])
    );
    return Array.from(
      new Set(
        matchedObjects.flatMap(obj => obj[extractKey] || [])
      )
    );
  }

  apply() {
    let getDateToggleData = this.service.getDateRangeToggleData();
    const data = {
      zone_id: this.selectedZonalMgrs.length > 0
        ? this.getUniqueIds(this.selectedZonalMgrs, 'zone_id')
        : this.selectedRegionalMgrs.length > 0
          ? this.getUniqueIdsFromLinkedArrays(
            this.selectedRegionalMgrs,
            this.selectedRegionalMgrsFull,
            'user_id',
            'zone_id'
          )
          : this.getUniqueIdsFromLinkedArrays(
            this.selectedAreaMgrs,
            this.selectedAreaMgrsFull,
            'user_id',
            'zone_id'
          ),

      region_id: this.getUniqueIdsFromLinkedArrays(
        this.selectedRegionalMgrs,
        this.selectedRegionalMgrsFull,
        'user_id',
        'region_id'
      ),

      state_id: this.getUniqueIdsFromLinkedArrays(
        this.selectedRegionalMgrs,
        this.selectedRegionalMgrsFull,
        'user_id',
        'state_id'
      ),

      parent_dealer_id: this.getUniqueIdsFromLinkedArrays(
        this.selectedAreaMgrs,
        this.selectedAreaMgrsFull,
        'user_id',
        'parent_dealer_id'
      ),

      outlet_id: this.showOutlets && this.selectedOutlets.length > 0
        ? this.selectedOutlets.map(o => o.id)
        : (this.selectedRegionalMgrs.length > 0 && this.selectedAreaMgrs.length == 0
          ? this.getUniqueIdsFromLinkedArrays(
            this.selectedRegionalMgrs,
            this.selectedRegionalMgrsFull,
            'user_id',
            'outlet_id'
          ) :
          this.getUniqueIdsFromLinkedArrays(
            this.selectedAreaMgrs,
            this.selectedAreaMgrsFull,
            'user_id',
            'outlet_id'
          )),
      // isApplyFilter: false
    };

    // Create the common object
    // const data = {
    //   zone_id: this.getUniqueIds([...this.selectedZonalMgrs, ...this.selectedRegionalMgrsFull, ...this.selectedAreaMgrsFull], 'zone_id'),
    //   region_id: this.getUniqueIds([...this.selectedZonalMgrs, ...this.selectedRegionalMgrsFull, ...this.selectedAreaMgrsFull], 'region_id'),
    //   state_id: this.getUniqueIds([...this.selectedZonalMgrs, ...this.selectedRegionalMgrsFull, ...this.selectedAreaMgrsFull], 'state_id'),
    //   parent_dealer_id: this.getUniqueIds([...this.selectedZonalMgrs, ...this.selectedRegionalMgrsFull, ...this.selectedAreaMgrsFull], 'parent_dealer_id'),
    //   outlet_id: this.getUniqueIds([...this.selectedZonalMgrs, ...this.selectedRegionalMgrsFull, ...this.selectedAreaMgrsFull], 'outlet_id'),
    // };
    // Use a new variable for the filtered result
    const filteredData: Record<string, any> = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => Array.isArray(value) && value.length > 0)
    );
    const hasKeys = Object.keys(filteredData).length > 0;
    if (hasKeys) {
      this.hasAppliedFilter = true;
    }
    if (!hasKeys && !this.hasAppliedFilter) {
      this.toaster.warning('Please select any filter!');
      return;
    }
    // filteredData['isApplyFilter'] = hasKeys;
    if (!hasKeys) {
      this.hasAppliedFilter = false;
    }
    if (getDateToggleData && getDateToggleData?.fromDate && getDateToggleData?.toDate) {
      filteredData['fromDate'] = getDateToggleData?.fromDate;
      filteredData['toDate'] = getDateToggleData?.toDate;
    }
    if (getDateToggleData && getDateToggleData?.hyperlocal_outlet) {
      filteredData['hyperlocal_outlet'] = getDateToggleData?.hyperlocal_outlet;
    }
    this.applyManagers.emit(filteredData);
    this.service.callAdvancedFilter(true);

    let obj = {
      // zone_id: [...this.zoneSet],
      region_user_id: [...this.regionSet],
      area_user_id: [...this.areaSet],
      //outlet_id: [...this.outletSet],
      ...filteredData
    }
    const filteredObj: Record<string, any> = Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => Array.isArray(value) && value.length > 0)
    );
    console.log('dirfilterObject', JSON.stringify(filteredObj, null, 2))
    sessionStorage.setItem("dirfilterObj", JSON.stringify(filteredObj));
  }

  showErrorForArea() {
    // if (this.role_id == this.ROLE_CONSTANTS.HO) {
    //   if (this.selectedZonalMgrs.length === 0 && this.selectedRegionalMgrs.length === 0) {
    //     this.toaster.error('Please select Zonal Manager and Regional Manager first!');
    //     return;
    //   } else if (this.selectedRegionalMgrs.length === 0) {
    //     this.toaster.error('Please select Regional Manager!');
    //   } else if (this.selectedZonalMgrs.length === 0) {
    //     this.toaster.error('Please select Zonal Manager!');
    //   }
    // } else if (this.role_id == this.ROLE_CONSTANTS.ZM) {
    //   if (this.selectedRegionalMgrs.length === 0) {
    //     this.toaster.error('Please select Regional Manager!');
    //   }
    // }
  }

  showErrorForRegion() {
    if (this.role_id == this.ROLE_CONSTANTS.HO) {
      if (this.selectedZonalMgrs.length === 0) {
        this.toaster.error('Please select Zonal Manager first!');
      }
    }
  }

  loadoutlets() {
    this.filterService.getOutletsDatabyOutletID().subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          this.OutletList = res.map((i: any) => ({
            id: Number(i.id),
            outlet_name: i.outlet_name
          }));
          console.log('outletSet values', this.outletSet.size);
          console.log('outletSet', this.outletSet);
          this.selectedOutlets = this.OutletList.filter((item: any) => this.outletSet.has(item.id));
        }
      },
      error: (err) => {
        console.error('API error:', err);
      }
    });
  }

  onOutletSelect(selectedItem: any) {
    console.log('on oulet select ', selectedItem)
    const outletId = Number(selectedItem.id);
    this.outletSet.add(outletId);
    this.isOutletSelect = true;

    const matchingRegions = this.AllRegionManagerList.filter((region: any) =>
      region.outlet_id?.some((id: any) => Number(id) === outletId)
    );
    const matchingAreas = this.AllAreaManagerList.filter((area: any) =>
      area.outlet_id?.some((id: any) => Number(id) === outletId)
    );
    const zoneIds = new Set<number>([
      ...matchingRegions.map((region: any) => Number(region.zone_id)),
      ...matchingAreas.map((area: any) => Number(area.zone_id))
    ]);

    this.selectedZonalMgrs = this.ZoneManagerList.filter((zone: any) =>
      zoneIds.has(Number(zone.zone_id))
    );
    this.selectedRegionalMgrs = matchingRegions;
    this.selectedRegionalMgrsFull = [...matchingRegions];
    this.selectedAreaMgrs = matchingAreas;
    this.selectedAreaMgrsFull = [...matchingAreas];
  }

  onOutletDeSelect(deSelectedItem: any) {
    this.outletSet.delete(deSelectedItem.id);
    if(this.outletSet.size > 0) {
      this.isOutletSelect = true;
    } else {
      this.isOutletSelect = false;
    }
  }

  showErrorForOutlets() {
    // if (this.role_id == this.ROLE_CONSTANTS.HO) {
    //   if (
    //     this.selectedZonalMgrs.length === 0 &&
    //     this.selectedRegionalMgrs.length === 0 &&
    //     this.selectedAreaMgrs.length === 0
    //   ) {
    //     this.toaster.error(
    //       "Please select Zonal Manager, Regional Manager and Area Manager first!"
    //     );
    //     return;
    //   } else if (this.selectedRegionalMgrs.length === 0) {
    //     this.toaster.error("Please select Regional Manager!");
    //   } else if (this.selectedZonalMgrs.length === 0) {
    //     this.toaster.error("Please select Zonal Manager!");
    //   } else if (this.selectedAreaMgrs.length === 0) {
    //     this.toaster.error("Please select Area Manager!");
    //   }
    // } else if (this.role_id == this.ROLE_CONSTANTS.ZM) {
    //   if (this.selectedRegionalMgrs.length === 0) {
    //     this.toaster.error("Please select Regional Manager!");
    //   }
    // }
  }
}
